export class EnvironmentConfig {
  appName: string;
  logoPath: string;
}
